import { IDataFieldsDrawing, IDataFieldsServiceAgreement, IDataFieldsServiceReport } from "@propely/propely-typings";

export function removeUndefinedFieldsServiceAgreements(obj: IDataFieldsServiceAgreement) {
  Object.keys(obj).forEach((key) => {
    const keyValue = obj[key as keyof IDataFieldsServiceAgreement];
    if (keyValue === undefined) {
      delete obj[key as keyof IDataFieldsServiceAgreement];
    }
  });
  return obj;
}

export function removeUndefinedFieldsServiceReport(obj: IDataFieldsServiceReport) {
  Object.keys(obj).forEach((key) => {
    const keyValue = obj[key as keyof IDataFieldsServiceReport];
    if (keyValue === undefined) {
      delete obj[key as keyof IDataFieldsServiceReport];
    }
  });
  return obj;
}

export function removeUndefinedFieldsDrawing(obj: IDataFieldsDrawing) {
  Object.keys(obj).forEach((key) => {
    const keyValue = obj[key as keyof IDataFieldsDrawing];
    if (keyValue === undefined) {
      delete obj[key as keyof IDataFieldsDrawing];
    }
  });
  return obj;
}

export const removeAllUndefinedFields = (obj: { [key: string]: any }) => {
  Object.keys(obj).forEach((key) => {
    const keyValue = obj[key];
    if (keyValue === undefined) {
      delete obj[key];
    }
  });
  return obj;
};
